import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorMessageOverviewComponent } from '../error-message-overview/error-message-overview.component';
import { SidebarComponent } from '../../../common/sidebar/sidebar.component';
import { ErrorMessageTableComponent } from '../../../tables/error-message/error-message-table/error-message-table.component';

@Component({
  selector: 'app-error-message-recycling-overview',
  imports: [SidebarComponent, CommonModule, RouterModule, ErrorMessageTableComponent],
  templateUrl: './error-message-recycling-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error-message-recycling-overview.component.scss',
})
export class ErrorMessageRecyclingOverviewComponent extends ErrorMessageOverviewComponent implements OnInit, OnDestroy {
  constructor() {
    super();
    this.recyclingModeEnabled = true;
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.sidebarConfiguration.editAreaEnabled = false;
    this.sidebarConfiguration.linkAreaEnabled = false;
  }
}
